import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { useLang } from "../context/LanguageContext";

// Language-aware Link: prefixes internal absolute paths with /en when the
// current language is English, so EN pages keep their own indexable URLs.
export const Link = ({ to, ...rest }) => {
  const { localizePath } = useLang();
  return <RouterLink to={localizePath(to)} {...rest} />;
};

export default Link;
